var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul class=\"search-result-list list-unstyled list-inline\">\n  <div class=\"panel-result-list\">\n    <div class=\"panel-body\">\n      <div class=\"spacer spacer-top\"/>\n      <ul class=\"selection-items list-unstyled list-inline result-list\"></ul>\n      <div class=\"spacer spacer-bottom\"/>\n    </div>\n  </div>\n</ul>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/combined/DownloadListView.hbs
// module id = 2064
// module chunks = 0